// extracted by mini-css-extract-plugin
export default {"video":"YoutubeEmbed_video__cfLkJ","iframe":"YoutubeEmbed_iframe__TEoS6"};